if (!window.clpOpinionesInitialized) {
  window.clpOpinionesInitialized = true;
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-opiniones-variant]')) return;
    const section = event.target.closest('[data-opiniones-product]');
    const variant = event.target.tagName === 'SELECT' ? event.target.selectedOptions[0] : event.target;
    if (!section || !variant) return;
    const price = section.querySelector('[data-opiniones-price]');
    const compare = section.querySelector('[data-opiniones-compare]');
    if (price) price.textContent = variant.dataset.price;
    if (compare) {
      compare.textContent = variant.dataset.compare;
      compare.hidden = !variant.dataset.compare;
    }
    section.querySelectorAll('[data-opiniones-inventory]').forEach((notice) => {
      const quantity = Number(variant.dataset.inventory);
      notice.hidden = !variant.dataset.tracked || quantity < 1 || quantity > Number(notice.dataset.limit);
      notice.textContent = notice.dataset.label.replace('[quantity]', String(quantity));
    });
    const media = variant.dataset.media && section.querySelector('[data-opiniones-media="' + variant.dataset.media + '"]');
    const gallery = section.querySelector('.clp-opiniones__gallery');
    if (media && gallery) gallery.scrollLeft = media.offsetLeft - gallery.offsetLeft;
  });
}

